module.exports = __webpack_public_path__ + "static/media/mifacturaperublanco.5abbfb99.png";